import React from 'react';
import { Button } from 'react-bootstrap';

interface ItineraryModalButtonProps {
  className?: string,
  style?: {
    [key: string]: string | number | undefined;
  },
  brandSetting?: {
    requireLodgingPkgQuote?: boolean;
  },
  itinerary: {
    lodgingItineraries?: any[];
    golfItineraries?: Array<{
      itineraryUnits: Array<{
        availableTimes: any[];
      }>;
    }>;
    transportItineraries?: any[];
    customItineraries?: any[];
  },
  setShowModal: (modalType: string) => void,
  buttonLabel: string,
  modalString: string,
  disabled?: boolean,
}

const ItineraryModalButton: React.FC<ItineraryModalButtonProps> = ({
  style = {},
  brandSetting,
  itinerary,
  setShowModal,
  modalString,
  buttonLabel,
  className,
}) => {
  const handleClick = () => {
    if (brandSetting !== undefined) {
      if (
        !brandSetting.requireLodgingPkgQuote ||
        (itinerary.lodgingItineraries !== undefined &&
          itinerary.lodgingItineraries.length > 0)
      ) {
        setShowModal(modalString);
      } else {
        setShowModal('lodging-required');
      }
    }

    let missing = false;
    if (itinerary.golfItineraries !== undefined) {
      itinerary.golfItineraries.forEach((i) =>
        i.itineraryUnits.forEach((u) => {
          if (u.availableTimes.length === 0) {
            missing = true;
          }
        })
      );
    }

    if (missing) setShowModal('missing-rate');
  };

  return (
    <Button
      className={className}
      style={style ? { ...style } : undefined}
      onClick={handleClick}
    >
      {buttonLabel}
    </Button>
  );
};

export default ItineraryModalButton;
